import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from '@ps-gui/shared-core';

@Component({
  selector: 'external-document-preview-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, ToastContainerComponent],
})
export class AppComponent {}
